import React from "react";

export function FormError(props){
  return (
    <React.Fragment>
      <span className="error"> {props.message} </span>
    </React.Fragment>
  )
}